import * as React from "react";
import { Label } from "../ui/Label";
import { FixedField } from "../../utils/needMath";
import Restriction from "../../icons/restriction.svg?react";
import Keto from "../../icons/keto.svg?react";
import LowCarb from "../../icons/low-carb.svg?react";
import LowFat from "../../icons/low-fat.svg?react";
import ChickenLeg from "../../icons/chicken-leg.svg?react";
import { Plan2PlanIconButtonWithTitle } from "./Plan2PlanIconButtonWithTitle";

export interface DietPreset {
  id: string;
  label: string;
  fatPercent: number;
  carbsPercent: number;
  proteinPercent: number;
  fixedField: FixedField;
  icon: React.ReactNode;
}

export const dietPresets: DietPreset[] = [
  {
    id: "balanced",
    label: "IIFYM",
    fatPercent: 30,
    carbsPercent: 40,
    proteinPercent: 30,
    fixedField: "proteinPercent",
    icon: <Restriction />,
  },
  {
    id: "keto",
    label: "Keto",
    fatPercent: 75,
    carbsPercent: 5,
    proteinPercent: 20,
    fixedField: "carbsPercent",
    icon: <Keto />,
  },
  {
    id: "lowCarb",
    label: "Low Carb",
    fatPercent: 60,
    carbsPercent: 20,
    proteinPercent: 20,
    fixedField: "carbsPercent",
    icon: <LowCarb />,
  },
  {
    id: "lowFat",
    label: "Low Fat",
    fatPercent: 20,
    carbsPercent: 55,
    proteinPercent: 25,
    fixedField: "fatPercent",
    icon: <LowFat />,
  },
  {
    id: "highProtein",
    label: "High Protein",
    fatPercent: 25,
    carbsPercent: 35,
    proteinPercent: 40,
    fixedField: "proteinPercent",
    icon: <ChickenLeg />,
  },
];

export function detectActivePreset(
  fatPercent: number,
  carbsPercent: number,
  proteinPercent: number,
): string | null {
  const matching = dietPresets.find(
    (p) =>
      Math.abs(p.fatPercent - fatPercent) < 1.5 &&
      Math.abs(p.carbsPercent - carbsPercent) < 1.5 &&
      Math.abs(p.proteinPercent - proteinPercent) < 1.5,
  );
  return matching?.id ?? null;
}

export interface DietPresetPickerProps {
  activeId: string | null;
  onPick: (preset: DietPreset) => void;
}

export const DietPresetPicker = ({
  activeId,
  onPick,
}: DietPresetPickerProps) => (
  <div>
    <Label>Diät-Preset</Label>
    <div className="mt-1.5 grid grid-cols-5 gap-2">
      {dietPresets.map((p) => {
        const isActive = activeId === p.id;
        const title = p.label;
        const icon = p.icon;
        return (
          <Plan2PlanIconButtonWithTitle
            key={p.id}
            ariaPressed={isActive}
            title={title}
            onClick={() => onPick(p)}
            icon={icon}
          />
        );
      })}
    </div>
  </div>
);
